import { SFTPUsersApi } from './permission-api-client';
import { initializePermissionApi } from './utils';

export const usersApi = initializePermissionApi(SFTPUsersApi);
